// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"u6-z","dimensionLabel":"v6-z","styleChooserControlWrapper":"w6-z","styleChooserControl":"x6-z","disabled":"y6-z","giftCard":"z6-z","styleChooserText":"A6-z"};